import React from 'react';
import { Chrome } from 'lucide-react';
import { AUTH_BASE_URL } from '../config/api';

const Login = () => {
  const handleGoogleLogin = () => {
    window.location.href = `${AUTH_BASE_URL}/api/auth/google`;
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Welcome to Supple Agentic Chat
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Sign in to start chatting with AI models
          </p>
        </div>
        <div className="mt-8 space-y-6">
          <button
            onClick={handleGoogleLogin}
            className="group relative w-full flex justify-center py-3 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <Chrome className="w-5 h-5 mr-2" />
            Continue with Google
          </button>
        </div>
        <div className="text-center text-xs text-gray-500">
          <p>By signing in, you agree to our Terms of Service and Privacy Policy</p>
        </div>
      </div>
    </div>
  );
};

export default Login;